/* ============================================================
   theme.js — site-wide shared scripts
   Loaded by every page. Keep small.
   ============================================================ */

/* === Footer accordion: open on desktop, closed on mobile === */
(function () {
  var BREAKPOINT = '(max-width: 880px)';
  var mq = window.matchMedia(BREAKPOINT);

  function adjust() {
    var isMobile = mq.matches;
    document.querySelectorAll('details.footer-col').forEach(function (d) {
      // If the user has manually toggled this <details>, leave it alone.
      if (d.dataset.userToggled === '1') return;
      if (isMobile) {
        d.removeAttribute('open');
      } else {
        d.setAttribute('open', '');
      }
    });
  }

  // Track manual user clicks so a user who opens a column on mobile
  // doesn't have it forced closed again on resize / reflow.
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('details.footer-col > summary');
    if (summary) {
      summary.parentElement.dataset.userToggled = '1';
    }
  });

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', adjust);
  } else {
    adjust();
  }

  // Re-evaluate on viewport change
  if (mq.addEventListener) {
    mq.addEventListener('change', adjust);
  } else if (mq.addListener) {
    mq.addListener(adjust);
  }
})();

/* === Main navigation: natural top flow, reveal fixed menu after it scrolls away === */
(function () {
  var nav = document.querySelector('nav.main');
  var announce = document.querySelector('.announce');
  var toggle = document.getElementById('nav-toggle');

  if (!nav) return;

  var lastY = window.scrollY || 0;
  var ticking = false;
  var navExitY = 0;
  var deltaThreshold = 4;

  function isMenuOpen() {
    return !!(toggle && toggle.checked);
  }

  function measure() {
    var wasFloating = nav.classList.contains('is-nav-floating');

    if (wasFloating) {
      nav.classList.remove('is-nav-floating', 'is-nav-hidden', 'is-nav-visible');
    }

    var announceHeight = announce ? announce.offsetHeight : 0;
    navExitY = Math.max(announceHeight + nav.offsetHeight, 1);

    if (wasFloating && window.scrollY > navExitY) {
      nav.classList.add('is-nav-floating');
    }
  }

  function resetToNormalFlow() {
    nav.classList.remove('is-nav-floating', 'is-nav-hidden', 'is-nav-visible');
  }

  function showFloatingNav() {
    nav.classList.add('is-nav-floating', 'is-nav-visible');
    nav.classList.remove('is-nav-hidden');
  }

  function hideFloatingNav() {
    nav.classList.add('is-nav-floating', 'is-nav-hidden');
    nav.classList.remove('is-nav-visible');
  }

  function update() {
    var currentY = Math.max(window.scrollY || 0, 0);
    var delta = currentY - lastY;

    if (currentY <= navExitY) {
      resetToNormalFlow();
      lastY = currentY;
      ticking = false;
      return;
    }

    if (isMenuOpen()) {
      showFloatingNav();
      lastY = currentY;
      ticking = false;
      return;
    }

    if (delta < -deltaThreshold) {
      showFloatingNav();
    } else if (delta > deltaThreshold) {
      hideFloatingNav();
    } else if (!nav.classList.contains('is-nav-floating')) {
      hideFloatingNav();
    }

    lastY = currentY;
    ticking = false;
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function refresh() {
    measure();
    requestUpdate();
  }

  function revealOnFocus() {
    if ((window.scrollY || 0) > navExitY) {
      showFloatingNav();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  window.addEventListener('load', refresh);
  window.addEventListener('resize', refresh);
  window.addEventListener('scroll', requestUpdate, { passive: true });

  if (toggle) {
    toggle.addEventListener('change', requestUpdate);
  }

  nav.addEventListener('focusin', revealOnFocus);
})();
/* ============================================================
   product-detail.js - page-specific scripts
   ============================================================ */

(function () {
  function initGallery() {
    document.querySelectorAll('.gallery').forEach(function (gallery) {
      var shell = gallery.closest('.gallery-shell');
      var thumb = shell ? shell.querySelector('.gallery-scrollbar span') : null;
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;
      var lastX = 0;
      var lastTime = 0;
      var velocity = 0;
      var inertiaFrame = 0;
      var scrollTimer = 0;

      function stopInertia() {
        if (inertiaFrame) {
          window.cancelAnimationFrame(inertiaFrame);
          inertiaFrame = 0;
        }
      }

      function showScrollbar() {
        if (shell) {
          shell.classList.add('is-scrolling');
        }
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          if (shell) {
            shell.classList.remove('is-scrolling');
          }
        }, 650);
      }

      function updateScrollbar() {
        if (!thumb || !shell) {
          return;
        }

        var maxScroll = gallery.scrollWidth - gallery.clientWidth;
        if (maxScroll <= 0) {
          shell.classList.add('has-no-scroll');
          thumb.style.width = '100%';
          thumb.style.transform = 'translateX(0)';
          return;
        }

        shell.classList.remove('has-no-scroll');
        var ratio = gallery.clientWidth / gallery.scrollWidth;
        var thumbWidth = Math.max(40, shell.clientWidth * ratio);
        var maxThumbX = shell.clientWidth - thumbWidth;
        var thumbX = maxThumbX * (gallery.scrollLeft / maxScroll);

        thumb.style.width = thumbWidth + 'px';
        thumb.style.transform = 'translateX(' + thumbX + 'px)';
      }

      function startInertia() {
        var speed = velocity;

        function step() {
          speed *= 0.94;

          if (Math.abs(speed) < 0.15) {
            inertiaFrame = 0;
            return;
          }

          gallery.scrollLeft -= speed * 16;
          showScrollbar();
          inertiaFrame = window.requestAnimationFrame(step);
        }

        stopInertia();
        inertiaFrame = window.requestAnimationFrame(step);
      }

      gallery.addEventListener('pointerdown', function (event) {
        isDown = true;
        stopInertia();
        gallery.classList.add('is-dragging');
        if (shell) {
          shell.classList.add('is-dragging');
        }
        showScrollbar();
        updateScrollbar();
        startX = event.clientX;
        lastX = event.clientX;
        lastTime = performance.now();
        velocity = 0;
        scrollLeft = gallery.scrollLeft;
        gallery.setPointerCapture(event.pointerId);
      });

      gallery.addEventListener('pointermove', function (event) {
        if (!isDown) {
          return;
        }

        event.preventDefault();
        gallery.scrollLeft = scrollLeft - (event.clientX - startX);
        var now = performance.now();
        var elapsed = Math.max(16, now - lastTime);
        velocity = (event.clientX - lastX) / elapsed;
        lastX = event.clientX;
        lastTime = now;
        showScrollbar();
        updateScrollbar();
      });

      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (eventName) {
        gallery.addEventListener(eventName, function () {
          if (!isDown) {
            return;
          }

          isDown = false;
          gallery.classList.remove('is-dragging');
          if (shell) {
            shell.classList.remove('is-dragging');
          }
          startInertia();
        });
      });

      gallery.addEventListener('scroll', function () {
        showScrollbar();
        updateScrollbar();
      }, { passive: true });

      window.addEventListener('resize', updateScrollbar);
      updateScrollbar();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }
})();
